import { ROLE_TYPES } from '@/Interfaces/Data';
import { useAppSelector } from '@/_store/hooks';
import { selectUser } from '@/_store/modules/auth/selectors';

export type CityFareFormAccessMode = 'full' | 'operational' | 'readonly';

function useCityFareFormAccess(): {
  isLogisticOperator: boolean;
  accessMode: CityFareFormAccessMode;
} {
  const user = useAppSelector(selectUser);

  const isLogisticOperator =
    user?.managerLogType === ROLE_TYPES.LOGISTIC_OPERATOR;

  if (!isLogisticOperator) {
    return {
      isLogisticOperator: false,
      accessMode: 'full',
    };
  }

  const canEditOperationalParams =
    !!user?.permissions?.city?.editFare || !!user?.permissions?.city?.all;

  return {
    isLogisticOperator: true,
    accessMode: canEditOperationalParams ? 'operational' : 'readonly',
  };
}

export { useCityFareFormAccess };
